import {
  BreakLine,
  EmptyInput,
  InputGroup, InputRow, ModelInput,
  RadioYesNoInput,
} from '@equifinance/shared';
import { BrokerDetailGenericSection } from '../../../components/BrokerDetailGenericSection';

export const principalCompanyDetailsRefName = 'principal-company-details';

export default function PrincipalCompanyDetailsSection() {
  return (
    <BrokerDetailGenericSection
      id={principalCompanyDetailsRefName}
      refName={principalCompanyDetailsRefName}
      title="Principal company details"
      level={1}
      onClickEdit={() => {}}
    >
      <InputGroup>
        <InputRow>
          <ModelInput
            label="FCA number"
            field="principalCompany.fcaNumber"
            required
          />
          <ModelInput
            label="Registered company name"
            field="principalCompany.registeredCompanyName"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Trading company name"
            field="principalCompany.tradingCompanyName"
            required
          />
          <ModelInput
            label="Registered company number"
            field="principalCompany.companyRegistrationNumber"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="ICO number"
            field="principalCompany.icoNumber"
            required
          />
          <ModelInput
            label="Company contact number"
            field="principalCompany.telephoneNumber"
            required
            tooltip="This should be the main office telephone number"
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Company email address"
            field="principalCompany.emailAddress"
            required
            tooltip="This should be the main company email address"
          />
          <RadioYesNoInput
            label="Permission to advise on regulated mortgage contracts?"
            field="principalCompany.hasRegulatoryPermission"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Company web address"
            field="principalCompany.webAddress"
            required
            tooltip="This should be the main company Web Address"
          />
          <EmptyInput />
        </InputRow>

        <BreakLine small />

        <InputRow>
          <ModelInput
            label="Flat/ sub building number"
            field="principalCompany.address.subBuilding"
            required
          />
          <ModelInput
            label="House / building number"
            field="principalCompany.address.houseNumber"
            required
          />
        </InputRow>
        <InputRow>
          <ModelInput
            label="House / building name"
            field="principalCompany.address.houseName"
            required
          />
          <ModelInput
            label="Street"
            field="principalCompany.address.street"
            required
          />
        </InputRow>
        <InputRow>
          <ModelInput
            label="Town / city"
            field="principalCompany.address.postTown"
            required
          />
          <ModelInput
            label="Postcode"
            field="principalCompany.address.postCode"
            required
          />
        </InputRow>
      </InputGroup>
    </BrokerDetailGenericSection>
  );
}
